module.exports = __webpack_public_path__ + "static/media/giphy_clone.75453906.png";